<div fxLayout="column" fxLayoutAlign="center stretch">
  <kendo-floatinglabel text="GL Code">
    <input (ngModelChange)="newGlCodeTextBoxChange($event)" [(ngModel)]="newGlCodeTextValue" name="code" required kendoTextBox/>
  </kendo-floatinglabel>

  <kendo-floatinglabel text="GL Description">
    <input (ngModelChange)="newGlDescriptionTextBoxChange($event)" [(ngModel)]="newGlDescriptionTextValue" name="desc"
           kendoTextBox/>
  </kendo-floatinglabel>
</div>

